import { render, staticRenderFns } from "./SelectChannelWarning.vue?vue&type=template&id=77cee19d&"
import script from "./SelectChannelWarning.vue?vue&type=script&lang=js&"
export * from "./SelectChannelWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports